<template>
  <div class="dwp-text-xl dwp-font-medium">
    <div class>
      <div
        data-cy="current-list-title"
        class="dwp-flex dwp-py-4 dwp-w-full dwp-items-center dwp-justify-between dwp-group dwp-relative dwp-z-20"
        v-if="currentList"
      >
        <ProgressBadge
          :percentage="currentPercentage"
          class="dwp-rounded-full dwp-w-6 dwp-h-6 dwp-duration-500 dwp-flex-shrink-0"
          :class="currentPercentage == 100 ? 'dwp-text-green-500 dwp-border-green-500' : 'dwp-text-primary dwp-border-primary'"
          style="border-width: 3px; padding: 2px; transition-property:border-color"
        />
        <span class="dwp-truncate dwp-ml-2">{{ currentList.title }}</span>
        <div
          class="dwp-mt-1 dwp-pl-2 dwp-ml-auto dwp-flex dwp-items-center dwp-justify-end dwp-text-gray-500 dwp-text-sm dwp-transition-opacity dwp-duration-200"
        >
          <div
            class="dwp-p-2 dwp-tooltip-wrap bottom"
            data-cy="save-list"
            @click="saveListModal.list = currentList; saveListModal.open = true"
          >
            <UploadCloudIcon class="dwp-w-4 dwp-h-4 dwp-cursor-pointer" style="fill:none" />
            <p class="dwp-tooltip">Save list as template</p>
          </div>
          <Dropdown :open.sync="menuOpen" position="right" widthClass="dwp-w-48">
            <MoreHorizontalIcon
              class="dwp-w-4 dwp-h-4 dwp-text-gray-500"
              data-cy="list-menu"
              @click="menuOpen = !menuOpen"
            />
            <template #list>
              <div class="dwp-divide-y dwp-divide-gray-200 dwp-py-1">
                <div>
                  <MenuItem
                    class="dwp-py-2 flex items-center"
                    @click.native="edit"
                    data-cy="edit-list"
                  >
                    <Edit2Icon
                      class="dwp-w-4 dwp-h-4 dwp-cursor-pointer dwp-mr-2 dwp-text-gray-500"
                      style="fill:none"
                    />
                    <div>Edit List</div>
                  </MenuItem>
                  <MenuItem
                    class="dwp-py-2 flex items-center"
                    @click.native="archive"
                    data-cy="archive-list"
                  >
                    <ArchiveIcon
                      class="dwp-w-4 dwp-h-4 dwp-cursor-pointer dwp-mr-2 dwp-text-gray-500"
                      style="fill:none"
                    />Archive List
                  </MenuItem>
                  <MenuItem
                    class="dwp-py-2 flex items-center"
                    @click.native="trash"
                    data-cy="trash-list"
                  >
                    <TrashIcon
                      class="dwp-w-4 dwp-h-4 dwp-cursor-pointer dwp-mr-2 dwp-text-gray-500"
                      style="fill:none"
                    />
                    <div>Trash List</div>
                  </MenuItem>
                </div>
              </div>
            </template>
          </Dropdown>
        </div>
      </div>
      <span v-else class="dwp-truncate">Choose A List</span>
    </div>
  </div>
</template>

<script>
import Dropdown from "@/components/ui/Dropdown.vue";
import MenuItem from "@/components/ui/MenuItem.vue";
import ProgressBadge from "@/components/ui/ProgressBadge.vue";
import { sync, get } from "vuex-pathify";
import { ChevronDownIcon } from "vue-feather-icons";
import currentList from "@/mixins/current-list";
import {
  MenuIcon,
  Edit2Icon,
  TrashIcon,
  ArchiveIcon,
  MoreHorizontalIcon,
  UploadCloudIcon,
} from "vue-feather-icons";

export default {
  mixins: [currentList],
  components: {
    MenuIcon,
    Dropdown,
    ArchiveIcon,
    MenuItem,
    UploadCloudIcon,
    MoreHorizontalIcon,
    Edit2Icon,
    TrashIcon,
    ProgressBadge,
    ChevronDownIcon,
  },

  data() {
    return {
      menuOpen: false,
    };
  },

  computed: {
    // ui
    modal: sync("ui/modal@list.new.open"),
    importModal: sync("ui/modal@list.import.open"),
    saveListModal: sync("ui/modal@list.save"),
    open: sync("ui/menu@open"),
    editList: sync("ui/modal@list.edit"),

    // tasks
    tasks: sync("tasks/items"),
    done() {
      return this.filterObject(this.tasks, (task) => {
        return task.done;
      });
    },
    otherLists() {
      return Object.values(this.lists).filter((list) => {
        return list?.id && list?.id !== this.currentlist?.id;
      });
    },

    currentPercentage() {
      if (!this?.currentList?.counts?.total) {
        return 0;
      }
      return (
        (this?.currentList?.counts?.done / this?.currentList?.counts?.total) *
        100
      );
    },
  },

  methods: {
    addNew() {
      this.open = false;
      this.modal = true;
    },

    edit() {
      this.editList = {
        open: true,
        list: this.currentList,
      };
    },

    async trash() {
      let r = confirm(
        "Are you sure you want to move this list and it's tasks to the trash?"
      );
      if (r) {
        this.$store.dispatch("lists/trashList", this.currentList);
        this.$store.commit("lists/resetCurrent");
        this.menuOpen = false;
      }
    },

    async archive() {
      this.$store.dispatch("lists/archive", this.currentList);
      this.menuOpen = false;
    },

    percentage(list) {
      if (!list?.counts?.total || !list?.counts?.done) {
        return 0;
      }
      return (list.counts.done / list.counts.total) * 100;
    },
  },
};
</script>